<div *ngIf="formUpdating"   class="margin-form-overlay">
  <mat-spinner diameter=32></mat-spinner>
</div>
<form [formGroup]="marginForm" (ngSubmit)="submit()" class="margin-form-container">
    <mat-form-field>
      <input matInput placeholder="General Expenses" type="number" formControlName="generalExpenses" readonly="readonly" i18n-placeholder>
      <span matSuffix>%</span>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Commission" type="number" formControlName="commission" i18n-placeholder>
      <span matSuffix>%</span>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Profit" type="number" formControlName="profit" readonly="readonly" i18n-placeholder>
      <span matSuffix>%</span>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="Customs duties" type="number" formControlName="customDuties" i18n-placeholder>
      <span matSuffix>%</span>
    </mat-form-field>
</form>


// WEBPACK FOOTER //
// ./src/app/budget/components/margin-form.component.html